import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { ALL_INSTANCES } = require('../Constants/instance.constants');
const { createRequest } = require('../../api/client');

export const getAllInstances = (data) => async (dispatch) => {
    const body = {};
    if (data.pageNo) {
        body.pageNo = data.pageNo;
    }

    if (data.resultsPerPage) {
        body.resultsPerPage = data.resultsPerPage;
    }
    const options = {
        url: `${Variable.backendUrl}/clients/getAllInstances`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body
    };
    try {
        const data = await createRequest(options);
        dispatch({
            type: ALL_INSTANCES,
            data
        });
    } catch (err) {
        handleExcception(err);
    }
};

export const getAllInstancesList = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/clients/getAllInstances`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const preUpgrade = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/upgrade/preUpgrade`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const startUpgrade = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/upgrade/startUpgrade`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};
